import type { FC } from 'react';
import { useReducer } from 'react';
import type { IContainerChildrenProps } from 'utils';
import { WebServiceContext } from './WebServiceContext';
import { WebServiceReducer } from './WebServiceReducer';

const WebServiceProvider: FC<IContainerChildrenProps> = ({ children }) => {
  const [state, dispatch] = useReducer(WebServiceReducer, { schema: {} });

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  return <WebServiceContext.Provider value={{ state, dispatch }}>{children}</WebServiceContext.Provider>;
};

export default WebServiceProvider;
